var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-row',{staticClass:"my-3 mx-3",staticStyle:{"display":"flex","justify-content":"center"}},[_c('b-col',[_c('b-button',{attrs:{"variant":"outline-success"},on:{"click":function($event){return _vm.navegar()}}},[_vm._v(" Navegar a Uno ")])],1),_c('b-col',[_vm._v(" "+_vm._s(this.curricula.nombre)+" ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }